import TopicPageTemplate from '@templates/topic-page/detail';

// ---------------------------------------------------------

import FlexibleDataOptimized, { fetchTopicPaths } from '@lib/cms/flexibleDataOptimized';

// ---------------------------------------------------------

export async function getStaticPaths() {
  const pathData = await fetchTopicPaths('HomeServices');

  const paths = pathData.map((item) => {
    return {
      params: { slug: item.slug }
    };
  });

  return {
    fallback: false,
    paths
  };
}

export async function getStaticProps(context) {
  const preview = context.preview || false;
  const previewEnv = context?.previewData?.environment || null;
  const pageData = await FlexibleDataOptimized.fetchTopicPage(
    'HomeServices',
    context.params.slug,
    preview,
    previewEnv
  );

  return {
    props: { pageData, preview }
  };
}

// ---------------------------------------------------------

const Home = ({ pageData, preview }) => {
  return (
    <TopicPageTemplate
      collection="HomeServices"
      coreService
      pageData={pageData}
      preview={preview}
    ></TopicPageTemplate>
  );
};

export default Home;
